module.exports = __webpack_public_path__ + "static/media/noShifts.b4e02f54.png";